import { AdminRouteName, OnboardingRouteName } from '@/constants';
import store from '@/store';
import PageNotFound from '@/views/PageNotFound.vue';
import { UserOnboardingStatus } from '@homeserve/od-typings/api';
import { authHelper } from '@homeserve/vue-auth-plugin';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('./views/Callback.vue'),
    },
    {
      path: '/admin',
      component: () => import('./layouts/Admin.vue'),
      children: [
        {
          path: '',
          redirect: { name: AdminRouteName.COMPANY },
        },
        {
          path: 'company',
          name: AdminRouteName.COMPANY,
          component: () => import('./views/Company.vue'),
          meta: { secured: true },
        },
        {
          path: 'agency',
          name: AdminRouteName.AGENCIES,
          component: () => import('./views/Agency.vue'),
          meta: { secured: true },
        },
        {
          path: 'profile',
          name: AdminRouteName.PROFILE,
          component: () => import('./views/Profile.vue'),
          meta: {
            secured: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { guest: true },
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: () => import('./views/ForgotPassword.vue'),
      meta: { guest: true },
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: () => import('./views/Onboarding.vue'),
      children: [
        {
          path: 'user',
          name: OnboardingRouteName.USER,
        },
        {
          path: 'company',
          name: OnboardingRouteName.COMPANY,
        },
        {
          path: 'catchment-area',
          name: OnboardingRouteName.CATCHMENT_AREA,
        },
        {
          path: 'skills',
          name: OnboardingRouteName.SKILLS,
        },
        {
          path: 'equipment',
          name: OnboardingRouteName.EQUIPMENT,
        },
        {
          path: 'documents',
          name: OnboardingRouteName.DOCUMENTS,
        },
        {
          path: 'summary',
          name: OnboardingRouteName.SUMMARY,
        },
      ],
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const {
    meta: { guest, secured },
  } = to;
  let isAuthenticated = authHelper.isUserAuthenticated(store);
  const user = store.getters['api/user/user/user'];
  const now = new Date();
  const future = now.setMinutes(now.getMinutes() + 30);
  const tokenWillExpired = store.getters['auth/tokenWillExpired'];
  const expiredInLessThan30Minutes = tokenWillExpired(future);

  if (isAuthenticated && expiredInLessThan30Minutes) {
    await authHelper.refreshToken(store);
  }

  isAuthenticated = authHelper.isUserAuthenticated(store);

  if (secured) {
    if (!isAuthenticated) {
      return next({
        name: 'login',
        query: { redirect: to.name! },
      });
    } else if (user && user.userStatus !== UserOnboardingStatus.DONE) {
      return next({ name: 'onboarding' });
    }
  } else if (guest && isAuthenticated) {
    return next({ name: AdminRouteName.COMPANY });
  }

  next();
});

export default router;
